import React, { useEffect, useState } from "react";
import classes from "./DashboardPage.module.css";
import { Button, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchAllServices,
  fetchClientOperatorApi,
  getMainServicesByCountryAndOperatorApi,
  getSubServiceDetailsApi,
} from "../Data/Api";
import axios from "axios";
import Loader from "../NewComponents/Loading-States/Loader";
import { toast, ToastContainer } from "react-toastify";
import NewSidebar from "../NewComponents/Sidebar/NewSidebar";
import NewHeader from "../NewComponents/Header/NewHeader";
import TitleHeader from "../NewComponents/Header/TitleHeader";
import { Dropdown } from "primereact/dropdown";

// DASHBOARD PAGE (ADD NETWORKS PAGE) It is an independent page + component as well which is used in service page that why it is getting the data as props from service page
const DashboardPage = ({
  serviceName,
  id,
  mainServiceId,
  mainServiceName,
  children,
  countryName,
  operatorName,
  allCountries,
  allOperators,
  allServices,
  filteredMainServices,
  showPublisher,
  allSubServices,
  filteredSubServices,
  resetPublisher
}) => {
  // if the service page is sending the data to dashboard page then store that in this.
  const [services, setServices] = useState(allServices ?? []);
  const [subServices, setSubServices] = useState(allSubServices ?? []);
  const [filteredServices, setFilteredServices] = useState(
    filteredSubServices ?? []
  );
  const [mainServices, setMainServices] = useState(filteredMainServices ?? []);
  const [loader, setLoader] = useState("block");

  const [countries, setCountries] = useState(allCountries ?? []);
  const [country, setCountry] = useState(countryName ?? "");
  const [operators, setOperators] = useState(allOperators ?? []);
  const [operator, setOperator] = useState(operatorName ?? "");

  const navigate = useNavigate();

  const [sidebarHide, setSidebarHide] = useState(() =>
    localStorage.getItem("sidebar")
      ? JSON.parse(localStorage.getItem("sidebar"))
      : false
  );
  const sidebarHandler = () => {
    localStorage.setItem("sidebar", JSON.stringify(!sidebarHide));
    setSidebarHide(JSON.parse(localStorage.getItem("sidebar")));
  };

  const getServicesByCountryAndOperator = async (
    countryParameter,
    operatorParameter
  ) => {
    setLoader("block");
    let token = localStorage.getItem("userToken");
    let headers = { Authorization: "Bearer " + token };
    try {
      console.log({ countryParameter, operatorParameter }, "co");
      let allServices = JSON.parse(localStorage.getItem("serviceObject"));
      console.log(allServices, "s");
      let filteredServices2 = allServices.filter(
        (service) =>
          service?.country == countryParameter &&
          service?.operator == operatorParameter
      );
      console.log(filteredServices2, "fs2");
      localStorage.setItem("showAddPublisher", false);
      if(resetPublisher){
        resetPublisher();
      }
      setLoader("none");
      setMainServices(filteredServices2);
      setFilteredServices([]);
    } catch (error) {
      setLoader("none");
      if (error?.response?.status == 403) {
        toast.error(
          error?.response?.data?.message ||
            error?.data?.message ||
            error?.message ||
            error
        );
        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        toast.error(
          error?.response?.data?.message ||
            error?.data?.message ||
            error?.message ||
            error
        );
      }
    }
  };

  console.log(mainServices, "ms");
  const fetchOperators = async (countryParameter) => {
    try {
      setLoader("block");

      let token = localStorage.getItem("userToken");

      let headers = { Authorization: "Bearer " + token };

      const data = {
        country: countryParameter,
      };

      const response = await axios.post(`${fetchClientOperatorApi}`, data, {
        headers: headers,
      });
      const dataa = response?.data?.data?.result;
      const filteredData = dataa.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.operator === item.operator)
      );

      setOperators(filteredData);

      localStorage.setItem("operators", JSON.stringify(filteredData));
      setOperator(response?.data?.data?.result[0]?.operator);

      getServicesByCountryAndOperator(
        countryParameter,
        response?.data?.data?.result[0]?.operator
      );
      setLoader("none");

      return response?.data?.data?.result[0];
    } catch (error) {
      setLoader("none");

      if (error?.response?.status == 403) {
        toast.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error?.message ||
            error
        );
        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        toast.error(
          error?.response?.data?.message ||
            error?.data?.message ||
            error?.message ||
            error
        );
      }
    }
  };

  // GET THE SERVICES DATA ....
  useEffect(() => {
    function mountData() {
      if (allServices && allSubServices && countryName) {
        // This statement runs when we are in service page....
        console.log("dont do anything!", showPublisher);
        setLoader("none");
        // It checks if the user has selected the countryName "All" than run this statement setting services data as all services else other.
        if (countryName == "All") {
          let main_services = JSON.parse(localStorage.getItem("serviceObject"));
          setMainServices(main_services);
        }
        localStorage.setItem("showAddPublisher", showPublisher);
      } else {

        //  This else statement will run if we are in dashboard page , and it will get all the services and we will also store the countries as well in state will country "All" selected by default.
        const fetchDataFromBackend = async () => {
          setLoader("block");
          let token = localStorage.getItem("userToken");
          let headers = { Authorization: "Bearer " + token };
          try {
            const response = await axios.post(fetchAllServices, "", {
              headers: headers,
            });
            console.log(response?.data?.data);
            setLoader("none");
            setSubServices(response.data.data);
          } catch (error) {
            setLoader("none");
            if (error?.response?.status == 403) {
              toast.error(
                error?.response?.data?.message ||
                  error?.data?.message ||
                  error?.message ||
                  error
              );
              setTimeout(() => {
                window.location.href = "/";
              }, 1500);
            } else {
              toast.error(
                error?.response?.data?.message ||
                  error?.data?.message ||
                  error?.message ||
                  error
              );
            }
          }
        };
        fetchDataFromBackend();
        let countriesData = JSON.parse(localStorage.getItem("country"));
        let main_services = JSON.parse(localStorage.getItem("serviceObject"));
        console.log(countriesData, "main_");
        setServices(main_services);
        setMainServices(main_services);
        setLoader("none");
        // fetchOperators(countriesData[0]?.country);
        setCountries([{ country: "All" }, ...countriesData]);
        setCountry("All");
        // This is localStorage state that we use when to show Publishers data table or not 
        // We show publisher data table only , when the user has selected the service + subservice
        localStorage.setItem("showAddPublisher", false);
      }
    }
    mountData();
  }, [allServices, allSubServices, countryName, showPublisher]);

  console.log(filteredServices, "fs...");

  // FUNCTION TO HANDLE SERVICE AND SUB-SERVICE CLICK
  const handleNavigateAndFilterServices = (
    path,
    serviceName,
    showAddPublisher,
    checkMainService,
    idMainService,
    nameMainService,
    countryParam,
    operatorParam
  ) => {
    console.log(services, "services...");
    console.log(
      {
        path,
        serviceName,
        showAddPublisher,
        checkMainService,
        idMainService,
        nameMainService,
        subServices,
      },
      "data. after clicking...."
    );
    setFilteredServices(() =>
      subServices.filter((service) => service?.service == serviceName)
    );

    // if (showAddPublisher) {
    //   localStorage.setItem("showAddPublisher", JSON.stringify(true));
    // } else {
    //   localStorage.setItem("showAddPublisher", JSON.stringify(false));
    // }

    if (checkMainService?.useMainService) {
      navigate(path, {
        state: {
          mainServiceId: mainServiceId,
          mainServiceName: mainServiceName,
          stopUseEffectInDashboard: true,
          showAddPublisher: showAddPublisher,
          country: countryParam,
          operator: operatorParam,
          mainServices: mainServices,
          allServices: JSON.parse(localStorage.getItem("serviceObject")),
          allCountries: [
            { country: "All" },
            ...JSON.parse(localStorage.getItem("country")),
          ],
          allOperators: operators,
          subServices: subServices,
          filteredSubServices: subServices.filter(
            (service) => service?.service == serviceName
          ),
        },
      });
    } else {
      navigate(path, {
        state: {
          mainServiceId: idMainService,
          mainServiceName: nameMainService,
          stopUseEffectInDashboard: true,
          showAddPublisher: showAddPublisher,
          country: countryParam,
          operator: operatorParam,
          mainServices: mainServices,
          allServices: JSON.parse(localStorage.getItem("serviceObject")),
          allCountries: [
            { country: "All" },
            ...JSON.parse(localStorage.getItem("country")),
          ],
          allOperators: operators,
          subServices: subServices,
          filteredSubServices: subServices.filter(
            (service) => service?.service == serviceName
          ),
        },
      });
    }
  };

  console.log(filteredServices, "fs");

  const [subServiceDetails, setSubServiceDetails] = useState({});
  const [subServiceDetailsLoading, setSubServiceDetailsLoading] =
    useState(false);

  const fetchSubServiceDetails = async (data, idx) => {
    try {
      setSubServiceDetailsLoading(true);
      let token = localStorage.getItem("userToken");
      const response = await axios.post(
        `${getSubServiceDetailsApi}`,
        {
          subServiceInfo: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response, "response...");
      setSubServiceDetails(
        response?.data?.result.length > 0 && response?.data?.result[0]
      );
      setSubServiceDetailsLoading(false);
    } catch (error) {
      setSubServiceDetailsLoading(false);

      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error?.message ||
          error
      );
    }
  };

  const handleCountryChange = (selectedCountry) => {
    if (selectedCountry == "All") {
      setCountry(selectedCountry);
      let main_services = JSON.parse(localStorage.getItem("serviceObject"));
      setMainServices(main_services);
      setFilteredServices([]);
      // navigate("/dashboard", { state: { change: true }, replace: true });
    } else {
      setCountry(selectedCountry);
      fetchOperators(selectedCountry);
      setFilteredServices([]);
      // navigate("/dashboard", { replace: true });
    }
  };

  const handleOperatorChange = (selectedOperator) => {
    setOperator(selectedOperator);
    getServicesByCountryAndOperator(country, selectedOperator);
    // navigate("/dashboard", { replace: true });
  };

  return (
    <>
      <Loader value={loader} />
      <ToastContainer />
      <div className={`${classes.main} ${sidebarHide && classes.short}`}>
        <div className={`${classes.sidebar} ${sidebarHide && classes.short}`}>
          <div
            className={`${classes.sidebar_header} ${
              sidebarHide && classes.short
            }`}
          >
            <img
              src="/assets/images/logo1.png"
              alt="Revenue portal"
              className={classes.sidebar_logo}
            />
            <h3 className={classes.dashboard_text}>Dashboard</h3>
          </div>
          <div className={classes.sidebar_icon}>
            <div className={classes.circle} onClick={sidebarHandler}>
              {sidebarHide ? (
                <i
                  className={`fa-solid fa-arrow-right ${classes.arrow_icon}`}
                ></i>
              ) : (
                <i
                  className={`fa-solid fa-arrow-left ${classes.arrow_icon}`}
                ></i>
              )}
            </div>
          </div>
          <NewSidebar highlight={3} sidebarHide={sidebarHide} />
        </div>
        <div className={classes.container}>
          <NewHeader service="All Services" highlight={3} />
          <div className={classes.sub_container}>
            <form className={classes.form}>
              <div className={classes.service}>
                <Dropdown
                  key={country}
                  value={country}
                  onChange={(e) => handleCountryChange(e.target.value)}
                  options={countries?.map((country) => ({
                    label: country?.country,
                    value: country?.country,
                  }))}
                  placeholder="Select a Country"
                  style={{ width: "100%" }}
                />
              </div>

              {country !== "All" && (
                <div className={classes.service}>
                  <Dropdown
                    key={operator}
                    value={operator}
                    onChange={(e) => handleOperatorChange(e.target.value)}
                    options={operators?.map((operator) => ({
                      label: operator?.operator,
                      value: operator?.operator,
                    }))}
                    // options={services}
                    // optionLabel="serviceName"
                    // optionValue="serviceName"
                    placeholder="Select a Operator"
                    style={{ width: "100%" }}
                  />
                </div>
              )}
            </form>

            <TitleHeader title="Main Services" icon="" />
            <div className={classes.flex_container}>
              {mainServices.map((service, i) => {
                return (
                  <div key={i} className={classes.flex_item}>
                    <Button
                      className={classes.btn}
                      // onClick={() => navigate(`/dashboard/${service.serviceName}/${service.id}`)}
                      onClick={() =>
                        handleNavigateAndFilterServices(
                          `/dashboard/${service.serviceName}/${service.id}`,
                          `${service.serviceName}`,
                          false,
                          { useMainService: false },
                          service?.id,
                          service?.serviceName,
                          country,
                          operator
                        )
                      }
                      variant={
                        (id == service.id &&
                          serviceName == service.serviceName) ||
                        (mainServiceId == service.id &&
                          mainServiceName == service.serviceName)
                          ? "contained"
                          : "outlined"
                      }
                      // color="error"
                      size="medium"
                    >
                      {service.serviceName}
                    </Button>
                  </div>
                );
              })}
            </div>

            {filteredServices.length > 0 && (
              <TitleHeader title="Sub Services" icon="" />
            )}

            <div className={classes.flex_container}>
              {filteredServices.map((service, i) => {
                return (
                  <div key={i} className={classes.flex_item}>
                    <div
                      className={classes.btn}
                      onMouseEnter={() => fetchSubServiceDetails(service, i)}
                      onMouseLeave={() => {
                        setSubServiceDetails({});
                      }}
                    >
                      <Tooltip
                        title={
                          <div style={{ whiteSpace: "pre-wrap" }}>
                            {subServiceDetailsLoading ? (
                              <div className={classes.details}>
                                <p className={classes.detail}>Loading...</p>
                              </div>
                            ) : subServiceDetails ? (
                              <>
                                <div className={classes.details}>
                                  <p className={classes.detail}>
                                    <span>Country:</span>{" "}
                                    {subServiceDetails?.country}
                                  </p>
                                  <p className={classes.detail}>
                                    <span>Operator:</span>{" "}
                                    {subServiceDetails?.operator}
                                  </p>
                                  <p className={classes.detail}>
                                    <span>ServiceUrl:</span>{" "}
                                    {subServiceDetails?.serviceUrl}
                                  </p>
                                  {/* <Button variant="outlined" color="inherit">
                                    Full Details
                                  </Button> */}
                                </div>
                              </>
                            ) : (
                              <div className={classes.details}>
                                <p className={classes.detail}>
                                  Details not Found!
                                </p>
                              </div>
                            )}
                          </div>
                        }
                      >
                        <Button
                          onClick={() => {
                            service?.serviceStatus === "Deactive"
                              ? toast.error(
                                  "This service is deactive right now!"
                                )
                              : handleNavigateAndFilterServices(
                                  `/dashboard/${service.subService}/${service.serviceId}`,
                                  `${service.service}`,
                                  true,
                                  { useMainService: true },
                                  null,
                                  null,
                                  country,
                                  operator
                                );
                          }}
                          variant={
                            id == service.serviceId &&
                            serviceName === service.subService
                              ? "contained"
                              : "outlined"
                          }
                          // color="error"
                          color={
                            service?.serviceStatus === "Deactive"
                              ? "error"
                              : "primary"
                          }
                          // color="error"
                          size="medium"
                        >
                          {service.subService}
                        </Button>
                      </Tooltip>

                      {/* {hoverState?.state && hoverState?.idx===i && 
                      <div className={classes.hover_info_box}>

                        </div>
                      } */}
                    </div>
                  </div>
                );
              })}
            </div>

            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPage;
